import { render, staticRenderFns } from "./m-plank-drawer.vue?vue&type=template&id=1aee652e&scoped=true&"
import script from "./m-plank-drawer.vue?vue&type=script&lang=js&"
export * from "./m-plank-drawer.vue?vue&type=script&lang=js&"
import style0 from "./m-plank-drawer.vue?vue&type=style&index=0&id=1aee652e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aee652e",
  null
  
)

export default component.exports